import React from 'react';
import { ShieldIcon, MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
import { Section } from './Shared';
import { SUPPORT_EMAIL, INSTAGRAM_URL, INSTAGRAM_HANDLE, SITE_URL, BRAND_NAME } from '../data/pack';
export const Guarantee = () => <Section className="max-w-3xl" data-id="element-72" data-mp="32lrmhejrmzki">
    <div className="paper-panel rounded-3xl p-8 text-center md:p-12" data-id="element-73" data-mp="36oxyz3xh1mzf">
      <ShieldIcon className="mx-auto mb-5 h-10 w-10 text-brand-goldDark md:h-12 md:w-12" strokeWidth={1.25} data-id="element-74" data-mp="36n3bpiyq9is6" />
      <h2 className="mb-5 font-display text-lg font-bold uppercase tracking-[0.14em] text-brand-burgundy md:text-2xl" data-id="element-75" data-mp="39904ifsbca6">
        7-Day Satisfaction Guarantee
      </h2>
      <p className="mb-4 text-base text-brand-text md:text-lg" data-id="element-76" data-mp="3lgonkhff80o6">
        Open the volumes. Explore the session library. Review the visual atlas
        and practical bonuses.
      </p>
      <p className="mb-6 text-base text-brand-text md:text-lg" data-id="element-77" data-mp="2a19tpmiidoxa">
        If the material is not what you expected, contact us within seven days
        of purchase to request a refund.
      </p>
      <p className="font-serif text-lg italic text-brand-goldDark md:text-xl" data-id="element-78" data-mp="3l9shv2i5sonf">
        Your purchase is protected.
      </p>
    </div>
  </Section>;
export const Contact = () => <Section className="max-w-3xl py-10 md:py-14" data-id="element-79" data-mp="3v8hp81cfiqpf">
    <div className="text-center" data-id="element-80" data-mp="3q8n0a3c7sb70">
      <h2 className="font-serif text-2xl font-semibold text-brand-burgundy md:text-3xl" data-id="element-81" data-mp="3q7lmvs7q7cm4">
        Questions before purchasing?
      </h2>
      <ul className="mt-6 flex flex-col items-center justify-center gap-4 text-sm md:flex-row md:gap-8 md:text-base" data-id="element-82" data-mp="80xjq7w8kzj3">
        <li data-id="element-83" data-mp="hstv2knc2m59">
          <a href={`mailto:${SUPPORT_EMAIL}`} className="inline-flex items-center gap-2 text-brand-goldDark transition-colors duration-200 ease-out hover:text-brand-burgundy" data-id="element-84" data-mp="hsk2cpawm0vv">
            <MailIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-85" data-mp="qt01jmkm6lux" />
            {SUPPORT_EMAIL}
          </a>
        </li>
        <li data-id="element-86" data-mp="mt7r14bnu5mx">
          <a href={INSTAGRAM_URL} className="inline-flex items-center gap-2 text-brand-goldDark transition-colors duration-200 ease-out hover:text-brand-burgundy" data-id="element-87" data-mp="mthhet0maet5">
            <InstagramIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-88" data-mp="yuh7kf8q9x3w" />
            {INSTAGRAM_HANDLE}
          </a>
        </li>
        <li data-id="element-89" data-mp="18k0srrjwy31x">
          <a href={SITE_URL} className="inline-flex items-center gap-2 text-brand-goldDark transition-colors duration-200 ease-out hover:text-brand-burgundy" data-id="element-90" data-mp="18jr3652s5xwr">
            <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-91" data-mp="1hkfgexkcnu8l" />
            www.lumenakasha.com
          </a>
        </li>
      </ul>
    </div>
  </Section>;
export const Footer = () => <footer className="border-t border-brand-gold/30 bg-brand-ink py-12 text-brand-surface/85" data-id="element-92" data-mp="1riv9h62xtdkq">
    <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-93" data-mp="3ob55fzlt0v3j">
      <div className="mb-10" data-id="element-94" data-mp="3od83n6x41ujc">
        <h2 className="mb-3 font-display text-xl font-bold uppercase tracking-[0.3em] text-brand-goldLight" data-id="element-95" data-mp="3t9yhropcug24">
          {BRAND_NAME}
        </h2>
        <p className="mx-auto max-w-2xl text-brand-surface/75" data-id="element-96" data-mp="2afwz4q22lr18">
          Professional digital resources for clearer, more structured and
          confident holistic practice.
        </p>
      </div>

      <div className="space-y-3 text-xs text-brand-surface/50 md:text-[13px]" data-id="element-97" data-mp="21nblfodaqaj9">
        <p data-id="element-98" data-mp="1worybkmyuspb">
          © Lumen Akasha™ 2026. All rights reserved. Reproduction, resale and
          redistribution are prohibited without express authorization.
        </p>
        <p data-id="element-99" data-mp="2pcnt2jsz6ajg">
          This is educational material and does not replace medical advice,
          diagnosis, treatment or professional certification.
        </p>
      </div>
    </div>
  </footer>;